module.exports = __webpack_public_path__ + "img/6.5f1fab69.png";